module.exports = __webpack_public_path__ + "media/images/country_flags/sl-f2b2d025bcd950a5e7282c6d602650ae.png";